export default function formatBytes(bytes: number | null) {
  if (bytes === null || bytes === undefined) return '-';
  if (bytes === 0) return '0 B';

  const labels = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));

  return `${parseFloat((bytes / 1024 ** i).toFixed(2))} ${labels[i]}`;
}
